export default __webpack_public_path__ + "static/media/356EBC_29_0.d623e3ac.woff2";